/**
 * @generated SignedSource<<1c995185bde9601c25602afaae7ab998>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
export type RateDisplayOptions = "BUNDLED" | "SEPARATE";
export type TransportationCode = "CADDIE" | "CADDIE_CART" | "CART" | "FULL_CART" | "MOTOR_PULL_CART" | "PRIVATE_CART" | "PULL_CART" | "SINGLE_CART" | "WALK";
import { FragmentRefs } from "relay-runtime";
export type TransportationTypeControlNode$data = {
  readonly agenda?: {
    readonly facility: {
      readonly club: {
        readonly supportsPrivate: boolean;
      } | null | undefined;
      readonly publicBookingPermissionSet: {
        readonly rateDisplay: RateDisplayOptions | null | undefined;
      } | null | undefined;
      readonly type: FacilityType;
    };
  };
  readonly transportationTypes?: ReadonlyArray<{
    readonly code: TransportationCode | null | undefined;
    readonly customCode: string | null | undefined;
    readonly eighteenHolePrice: number | null | undefined;
    readonly enabled: boolean;
    readonly id: string;
    readonly name: string | null | undefined;
    readonly nineHolePrice: number | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"BundledTransportationTypeSelectNode" | "TransportationTypeSelectNode">;
  readonly " $fragmentType": "TransportationTypeControlNode";
};
export type TransportationTypeControlNode$key = {
  readonly " $data"?: TransportationTypeControlNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"TransportationTypeControlNode">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "memberId",
  "variableName": "memberId"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "memberId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "membershipTypeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TransportationTypeControlNode",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": [
            (v0/*: any*/),
            {
              "kind": "Variable",
              "name": "membershipTypeId",
              "variableName": "membershipTypeId"
            }
          ],
          "kind": "FragmentSpread",
          "name": "BundledTransportationTypeSelectNode"
        },
        {
          "args": [
            (v0/*: any*/)
          ],
          "kind": "FragmentSpread",
          "name": "TransportationTypeSelectNode"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PublicBookingPermissionSet",
                  "kind": "LinkedField",
                  "name": "publicBookingPermissionSet",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rateDisplay",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Club",
                  "kind": "LinkedField",
                  "name": "club",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "supportsPrivate",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            (v0/*: any*/),
            {
              "kind": "Literal",
              "name": "memberVisible",
              "value": true
            }
          ],
          "concreteType": "TransportationType",
          "kind": "LinkedField",
          "name": "transportationTypes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "customCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "enabled",
              "storageKey": null
            },
            {
              "alias": "nineHolePrice",
              "args": [
                {
                  "kind": "Literal",
                  "name": "holeCount",
                  "value": "NINE"
                }
              ],
              "kind": "ScalarField",
              "name": "totalPrice",
              "storageKey": "totalPrice(holeCount:\"NINE\")"
            },
            {
              "alias": "eighteenHolePrice",
              "args": [
                {
                  "kind": "Literal",
                  "name": "holeCount",
                  "value": "EIGHTEEN"
                }
              ],
              "kind": "ScalarField",
              "name": "totalPrice",
              "storageKey": "totalPrice(holeCount:\"EIGHTEEN\")"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Slot",
      "abstractKey": "__isSlot"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "c4436b098c48915afc612f69458e627b";

export default node;
